import { handleResponseError, throwIfFailed } from 'helpers/utils'
import { API } from './endpoint'
import {
  GetOrderCancelResponse, GetOrderCompleteResponse, GetPendingSkuResponse, GetWaitingShipResponse, MakeappointmentInput, MakeappointmentResponse, NewOrderResponse, GetOrderProductSkuListInput, GetOrderProductSkuListResponse, UpdateCapacityInput, UpdateCapacityResponse, SubmitNewOrderInput, SubmitNewOrderResponse, GetDataThaipostResponse, GetExportOrderThaipostResponse, GetOrderWaitingRefundResponse, UpdateApproveRequestCancelResponse, UpdateApproveRequestCancelInput, UpdateDeleteRequestCancelResponse, UpdateDeleteRequestCancelInput, MakeOrderConfirmInput, GetOrderproductskuNewOrderResponse, GetOrderproductskuNewOrderInput, CreateOrderTransactionInput, CreateOrderTransactionResponse, GetLoadNewOrderSkuInput, GetLoadNewOrderSkuResponse, OrderDistributedResponse, LotTransactionDetailInput, LotTransactionDetailResponse, OlderLotTransactionResponse, OlderLotTransactionInput, ExportOrderTransaferInput, ExportOrderTransaferResponse, OrderTransactionInput, OrderDistributedListResponse, UpdateOrderTransactionInput, UpdateOrderTransactionResponse, FactoryCreateOrderResponse, FactoryCreateOrderInput, ConfirmManualPaymentResponse, ConfirmManualPaymentInput, ConfirmManualPaymentBatchResponse, ConfirmManualPaymentBatchInput, GetDataOrderListResponse, GetDataOrderListRequest, GetOrderDetailInput, GetOrderDetailResponse, ConfirmTransportResponse, InputConfirmTransport, FactoryUpdateOrderInput, FactoryUpdateOrderResponse, UpdateOrderCompleteResponse, UpdateOrderCompleteInput, PricetransportationResponse, PriceTransportationInput, CancelOrderResponse, CancelOrderInput, SendProductionExportResponse, refundApproveResponse, refundApproveInput, UpdateManualPaymentResponse, GetOrderRepeatInput, refundPaymentInput, refundPaymentResponse, DetailRefundResponse, LoadTaxInvoiceListInput, LoadTaxInvoiceListResponse, CreateTaxInvoiceInput, CreateTaxInvoiceResponse, DeleteTaxInvoiceResponse, DeleteTaxInvoiceInput, updateReadOrderResponse, updateReadOrderInput, getTaxInvoiceByOrderIdResponse, LoadTaxInvoiceDataInput, LoadTaxInvoiceDataResponse, getTaxInvoiceByOrderIdInput, CheckSpeedMerchantStatusResponse, CheckThailandPostMerchantStatusResponse, CheckShippingItemsResponse, RevertManualOrderInput, RevertManualOrderResponse,
  ApiSpeedCreateShipmentInput,
  ApiSpeedCreateShipmentResponse,
  RetryShipmentInput,
  RetryShipmentResponse,
  ApiCreateShippingQueueInput,
  ApiCreateShippingQueueResponse,
  ApiGetShippingQueueStatusResponse,
  ApiGetAlternativeCarriersResponse,
  ApiGetShippingItemsResponse,
  GetOrderTracksRequest, GetOrderTracksResponse, UpdateTrackingPrintRequest, UpdateTrackingPrintResponse, GetTransportBrandsResponse,
  SaveSelfTrackingByItemInput, SaveSelfTrackingByItemResponse
} from './interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'

export const getDataNewOrder = async (
  input: GetDataOrderListRequest
): Promise<GetDataOrderListResponse> => {
  const data: AxiosResponse<GetDataOrderListResponse> = await httpClient
    .post(API.getDataNewOrder, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const getNewOrder = async (): Promise<NewOrderResponse> => {
  const data: AxiosResponse<NewOrderResponse> = await httpClient
    .get(API.getNewOder)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderPayment = async (): Promise<NewOrderResponse> => {
  const data: AxiosResponse<NewOrderResponse> = await httpClient
    .get(API.getOrderPayment)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getInprocess = async (): Promise<NewOrderResponse> => {
  const data: AxiosResponse<NewOrderResponse> = await httpClient
    .get(API.getOrderInprocess)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getWaitingShip = async (): Promise<GetWaitingShipResponse> => {
  const data: AxiosResponse<GetWaitingShipResponse> = await httpClient
    .get(API.getWaitingShip)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderComplete = async (): Promise<GetOrderCompleteResponse> => {
  const data: AxiosResponse<GetOrderCompleteResponse> = await httpClient
    .get(API.getOrderComplete)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderWaitingRefund = async (): Promise<GetOrderWaitingRefundResponse> => {
  const data: AxiosResponse<GetOrderWaitingRefundResponse> = await httpClient
    .get(API.getWaitingRefund)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderCancel = async (): Promise<GetOrderCancelResponse> => {
  const data: AxiosResponse<GetOrderCancelResponse> = await httpClient
    .get(API.getOrderCancel)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getPendingsku = async (): Promise<GetPendingSkuResponse> => {
  const data: AxiosResponse<GetPendingSkuResponse> = await httpClient
    .get(API.getPendingsku)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateApproveRequestCancel = async (
  input: UpdateApproveRequestCancelInput
): Promise<UpdateApproveRequestCancelResponse> => {
  const data: AxiosResponse<UpdateApproveRequestCancelResponse> = await httpClient
    .post(API.updateApproveRequestCancel, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateDeleteRequestCancel = async (
  input: UpdateDeleteRequestCancelInput
): Promise<UpdateDeleteRequestCancelResponse> => {
  const data: AxiosResponse<UpdateDeleteRequestCancelResponse> = await httpClient
    .post(API.updateDeleteRequestCancel, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const cancelOrder = async (
  input: CancelOrderInput
): Promise<CancelOrderResponse> => {
  const data: AxiosResponse<CancelOrderResponse> = await httpClient
    .post(API.cancelOrder, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const postMakeappointment = async (
  input: MakeappointmentInput
): Promise<MakeappointmentResponse> => {
  const data: AxiosResponse<MakeappointmentResponse> = await httpClient
    .post(API.makeappointment, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderProductSkuList = async (
  input: GetOrderProductSkuListInput
): Promise<GetOrderProductSkuListResponse> => {
  const data: AxiosResponse<GetOrderProductSkuListResponse> = await httpClient
    .post(API.orderProductSku, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const postUpdateCapacity = async (
  input: UpdateCapacityInput
): Promise<UpdateCapacityResponse> => {
  const data: AxiosResponse<UpdateCapacityResponse> = await httpClient
    .post(API.updateCapacity, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const submitNewOrderInput = async (
  input: SubmitNewOrderInput
): Promise<SubmitNewOrderResponse> => {
  const data: AxiosResponse<SubmitNewOrderResponse> = await httpClient
    .post(API.submitNewOrder, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getDataThaipost = async (): Promise<GetDataThaipostResponse> => {
  const data: AxiosResponse<GetDataThaipostResponse> = await httpClient
    .get(API.getOrderThaipost)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getExportDataThaipost = async (): Promise<GetExportOrderThaipostResponse> => {
  const data: AxiosResponse<GetExportOrderThaipostResponse> = await httpClient
    .get(API.getExportOrderToThaiPost)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getRepeatOrderRetail = async (
  input: GetOrderRepeatInput
): Promise<GetOrderDetailResponse> => {
  const data: AxiosResponse<GetOrderDetailResponse> = await httpClient
    .post(API.getRepeatOrderRetail, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderproductskuNewOrder = async (
  input: GetOrderproductskuNewOrderInput
): Promise<GetOrderproductskuNewOrderResponse> => {
  const data: AxiosResponse<GetOrderproductskuNewOrderResponse> = await httpClient
    .post(API.getOrderproductskuNewOrder, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const postMakeOrderConfirm = async (
  input: MakeOrderConfirmInput
): Promise<MakeappointmentResponse> => {
  const data: AxiosResponse<MakeappointmentResponse> = await httpClient
    .post(API.makeOrderConfirm, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createOrderTransaction = async (
  input: CreateOrderTransactionInput
): Promise<CreateOrderTransactionResponse> => {
  const data: AxiosResponse<CreateOrderTransactionResponse> = await httpClient
    .post(API.createOrderTransaction, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const rollbackOrderTransaction = async (
  input: UpdateOrderTransactionInput
): Promise<UpdateOrderTransactionResponse> => {
  const data: AxiosResponse<UpdateOrderTransactionResponse> = await httpClient
    .post(API.rollbackOrderTransaction, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getLoadNewOrderSku = async (
  input: GetLoadNewOrderSkuInput
): Promise<GetLoadNewOrderSkuResponse> => {
  const data: AxiosResponse<GetLoadNewOrderSkuResponse> = await httpClient
    .post(API.getLoadNewOrderSku, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderDistributed = async (
  input: string): Promise<OrderDistributedResponse> => {
  const data: AxiosResponse<OrderDistributedResponse> = await httpClient
    .get(API.getOrderDistributed + input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderDistributedList = async (
  input: OrderTransactionInput
): Promise<OrderDistributedListResponse> => {
  const data: AxiosResponse<OrderDistributedListResponse> = await httpClient
    .post(API.getOrderDistributedList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getLotTransactionDetail = async (
  input: LotTransactionDetailInput
): Promise<LotTransactionDetailResponse> => {
  const data: AxiosResponse<LotTransactionDetailResponse> = await httpClient
    .post(API.getDetailLotTransaction, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOlderLotTransaction = async (
  input: OlderLotTransactionInput
): Promise<OlderLotTransactionResponse> => {
  const data: AxiosResponse<OlderLotTransactionResponse> = await httpClient
    .post(API.getOlderLotTransaction, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getExportOrderTransafer = async (
  input: ExportOrderTransaferInput
): Promise<ExportOrderTransaferResponse> => {
  const data: AxiosResponse<ExportOrderTransaferResponse> = await httpClient
    .post(API.getExportOrderTransafer, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createOrderAdmin = async (
  input: FactoryCreateOrderInput
): Promise<FactoryCreateOrderResponse> => {
  const data: AxiosResponse<FactoryCreateOrderResponse> = await httpClient
    .post(API.createOrderAdmin, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateOrderAdmin = async (
  input: FactoryUpdateOrderInput
): Promise<FactoryUpdateOrderResponse> => {
  const data: AxiosResponse<FactoryUpdateOrderResponse> = await httpClient
    .post(API.updateOrderAdmin, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const confirmManualPayment = async (
  input: ConfirmManualPaymentInput
): Promise<ConfirmManualPaymentResponse> => {
  const data: AxiosResponse<ConfirmManualPaymentResponse> = await httpClient
    .post(API.confirmManualPayment, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const confirmManualPaymentBatch = async (
  input: ConfirmManualPaymentBatchInput
): Promise<ConfirmManualPaymentBatchResponse> => {
  const data: AxiosResponse<ConfirmManualPaymentBatchResponse> = await httpClient
    .post(API.confirmManualPaymentBatch, input, {
      /** นานกว่า default 10s — batch ยืนยันหลายออเดอร์ต่อ request */
      timeout: 300_000,
    })
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateManualPayment = async (
  input: ConfirmManualPaymentInput
): Promise<UpdateManualPaymentResponse> => {
  const data: AxiosResponse<UpdateManualPaymentResponse> = await httpClient
    .post(API.updateManualPayment, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const revertManualOrder = async (
  input: RevertManualOrderInput
): Promise<RevertManualOrderResponse> => {
  const data: AxiosResponse<RevertManualOrderResponse> = await httpClient
    .post(API.revertManualOrder, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getOrderDetail = async (
  input: GetOrderDetailInput
): Promise<GetOrderDetailResponse> => {
  const data: AxiosResponse<GetOrderDetailResponse> = await httpClient
    .post(API.getOrderDetail, input, {
      /** นานกว่า default 10s — detail หลายออเดอร์ query หนัก */
      timeout: 120_000,
    })
    .catch((error) => handleResponseError(error))
  return data.data
}

//confirm order transport
export const confirmOrderTransport = async (
  input: InputConfirmTransport
): Promise<ConfirmTransportResponse> => {
  const data: AxiosResponse<ConfirmTransportResponse> = await httpClient
    .post(API.confirmOrderTransport, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateOrderComplete = async (
  input: UpdateOrderCompleteInput
): Promise<UpdateOrderCompleteResponse> => {
  const data: AxiosResponse<UpdateOrderCompleteResponse> = await httpClient
    .post(API.updateOrderComplete, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getPriceTransportation = async (
  input: PriceTransportationInput
): Promise<PricetransportationResponse> => {
  const data: AxiosResponse<PricetransportationResponse> = await httpClient
    .post(API.getPriceTransportation, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getSendProductionExport = async (): Promise<SendProductionExportResponse> => {
  const data: AxiosResponse<SendProductionExportResponse> = await httpClient
    .get(API.getListSendProductExport)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const refundApprove = async (
  input: refundApproveInput
): Promise<refundApproveResponse> => {
  const data: AxiosResponse<refundApproveResponse> = await httpClient
    .post(API.refundApprove, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const refundPayment = async (
  input: refundPaymentInput
): Promise<refundPaymentResponse> => {
  const data: AxiosResponse<refundPaymentResponse> = await httpClient
    .post(API.refundPayment, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getDetailRefund = async (input: string): Promise<DetailRefundResponse> => {
  const data: AxiosResponse<DetailRefundResponse> = await httpClient
    .get(API.getDetailRefund + input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const loadTaxInvoiceList = async (
  input: LoadTaxInvoiceListInput
): Promise<LoadTaxInvoiceListResponse> => {
  const data: AxiosResponse<LoadTaxInvoiceListResponse> = await httpClient
    .post(API.loadTaxInvoiceList, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createTaxInvoice = async (
  input: CreateTaxInvoiceInput
): Promise<CreateTaxInvoiceResponse> => {
  const data: AxiosResponse<CreateTaxInvoiceResponse> = await httpClient
    .post(API.createTaxInvoice, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteTaxInvoice = async (
  input: DeleteTaxInvoiceInput
): Promise<DeleteTaxInvoiceResponse> => {
  const data: AxiosResponse<DeleteTaxInvoiceResponse> = await httpClient
    .post(API.deleteTaxInvoice, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateReadOrder = async (
  input: updateReadOrderInput
): Promise<updateReadOrderResponse> => {
  const data: AxiosResponse<updateReadOrderResponse> = await httpClient
    .post(API.updateReadOrder, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getTaxInvoiceByOrderId = async (
  input: getTaxInvoiceByOrderIdInput
): Promise<getTaxInvoiceByOrderIdResponse> => {
  const data: AxiosResponse<getTaxInvoiceByOrderIdResponse> = await httpClient
    .post(API.getTaxInvoiceByOrderId, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const loadTaxInvoiceData = async (
  input: LoadTaxInvoiceDataInput
): Promise<LoadTaxInvoiceDataResponse> => {
  const data: AxiosResponse<LoadTaxInvoiceDataResponse> = await httpClient
    .post(API.loadTaxInvoiceData, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const checkSpeedMerchantStatus = async (): Promise<CheckSpeedMerchantStatusResponse> => {
  const data: AxiosResponse<CheckSpeedMerchantStatusResponse> = await httpClient
    .post(API.checkSpeedMerchantStatus)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const checkThailandPostMerchantStatus = async (): Promise<CheckThailandPostMerchantStatusResponse> => {
  const data: AxiosResponse<CheckThailandPostMerchantStatusResponse> = await httpClient
    .post(API.checkThailandPostMerchantStatus)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const checkShippingItems = async (
  order_ids: string[]
): Promise<CheckShippingItemsResponse> => {
  const data: AxiosResponse<CheckShippingItemsResponse> = await httpClient
    .post(API.checkShippingItems, { order_ids })
    .catch((error) => handleResponseError(error))
  return data.data
}

export const apiSpeedCreateShipment = async (
  input: ApiSpeedCreateShipmentInput
): Promise<ApiSpeedCreateShipmentResponse> => {
  const data: AxiosResponse<ApiSpeedCreateShipmentResponse> = await httpClient
    .post(API.apiSpeedCreateShipment, input, { timeout: 60000 })
    .catch((error) => handleResponseError(error))
  return data.data
}

export const apiCreateShippingQueue = async (
  input: ApiCreateShippingQueueInput
): Promise<ApiCreateShippingQueueResponse> => {
  const data: AxiosResponse<ApiCreateShippingQueueResponse> = await httpClient
    .post(API.apiCreateShippingQueue, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const apiGetShippingQueueStatus = async (
  order_ids: string[]
): Promise<ApiGetShippingQueueStatusResponse> => {
  const orderIdsStr = order_ids.join(',');
  const data: AxiosResponse<ApiGetShippingQueueStatusResponse> = await httpClient
    .get(`${API.apiGetShippingQueueStatus}?order_ids=${orderIdsStr}`)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const apiGetAlternativeCarriers = async (
  verify_id: string
): Promise<ApiGetAlternativeCarriersResponse> => {
  const data: AxiosResponse<ApiGetAlternativeCarriersResponse> = await httpClient
    .get(`${API.apiGetAlternativeCarriers}/${verify_id}`)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const apiGetShippingItems = async (
  input: { order_id: string, status?: string[] }
): Promise<ApiGetShippingItemsResponse> => {
  const data: AxiosResponse<ApiGetShippingItemsResponse> = await httpClient
    .post(API.apiGetShippingItems, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const retryShipment = async (
  input: RetryShipmentInput
): Promise<RetryShipmentResponse> => {
  const data: AxiosResponse<RetryShipmentResponse> = await httpClient
    .post(API.retryShipment, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// โหลดรายการ Track การจัดส่งทั้งหมด (Factory) - ปริ้น Label ขนส่ง
export const getOrderTracks = async (
  input: GetOrderTracksRequest
): Promise<GetOrderTracksResponse> => {
  const data: AxiosResponse<GetOrderTracksResponse> = await httpClient
    .post(API.getOrderTracks, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// อัปเดตสถานะพิมพ์ (Tracking Print) — มาร์กว่าพิมพ์แล้ว
export const updateTrackingPrint = async (
  input: UpdateTrackingPrintRequest
): Promise<UpdateTrackingPrintResponse> => {
  const res: AxiosResponse<{ data: UpdateTrackingPrintResponse }> = await httpClient
    .post(API.updateTrackingPrint, input)
    .catch((error) => handleResponseError(error))
  return res.data.data
}

// ดึงรายการ Transport Brand สำหรับ dropdown (GET) (Speed Shipping)
export const getTransportBrands = async (): Promise<GetTransportBrandsResponse> => {
  const data: AxiosResponse<GetTransportBrandsResponse> = await httpClient
    .get(API.getTransportBrands)
    .catch((error) => handleResponseError(error))
  return data.data
}

// ดึงรายการ Transport Brand สำหรับ dropdown (GET) จาก master_by_process
export const getSelfShippingBrands = async (): Promise<any> => {
  const data = await httpClient
    .get('/master/master_by_process/self_shipping_carrier')
    .catch((error) => handleResponseError(error))
  return data.data
}

// [DEV/TEST ONLY] Trigger Shipping Cron manually
export const triggerShippingCron = async (): Promise<{ status: string; data: { message: string } }> => {
  const data = await httpClient
    .post(API.triggerShippingCron)
    .catch((error) => handleResponseError(error))
  return data.data
}

// บันทึกข้อมูล self tracking (บริษัทขนส่ง + เลขพัสดุ) สำหรับ self shipping
export const saveSelfTracking = async (input: {
  verify_id: string;
  self_transport_brand_id?: string;
  self_tracking_number: string;
}): Promise<{ status: string; data: { message: string } }> => {
  const data = await httpClient
    .post(API.saveSelfTracking, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// บันทึกเลขพัสดุจริงของรายการ "ส่งเอง" ด้วย retail_order_item_id — ใช้ได้ทั้งก่อน/หลังเรียกขนส่ง
// tracking_number: 1 เลข = ใช้กับทุกชิ้น, item_qty เลข = ใส่ทีละชิ้น · backend สร้างแถวจัดส่งให้เองถ้ายังไม่มี
export const saveSelfTrackingByItem = async (
  input: SaveSelfTrackingByItemInput
): Promise<SaveSelfTrackingByItemResponse> => {
  const data: AxiosResponse<SaveSelfTrackingByItemResponse> = await httpClient
    .post(API.saveSelfTrackingByItem, input)
    .catch((error) => handleResponseError(error))
  return throwIfFailed(data.data)
}

// ยืนยันการจัดส่งแบบ Manual โดยใช้ order_id
export const confirmOrderShipped = async (input: { order_id: string }): Promise<any> => {
  const data = await httpClient
    .post('/factory/orders/confirm-shipped-by-order', input)
    .catch((error) => handleResponseError(error))
  return data.data
}

// ดึง TP Label URL — ถ้า image_url มีอยู่คืนทันที ถ้าไม่มีจะดึงจาก TP API แล้วบันทึก
export const getTpLabelUrl = async (barcode: string): Promise<{ image_url: string }> => {
  const data = await httpClient
    .get(`${API.getTpLabel}/${barcode}`)
    .catch((error) => handleResponseError(error))
  return data.data.data
}
